module.exports = __webpack_public_path__ + "img/money-alt.1958ab81.svg";